import { FC } from 'react';
import { menuContainerVariants, menuVariants } from '../subMenu/SubMenuMobile.animate';
import { ChildrenList, ChildrenListTitle, MenuListContainer } from '../subMenu/SubMenuMobile.style';
interface Props {
  onCloseMenu: () => void;
}
const PromotionMenuMobile: FC<Props> = ({
  onCloseMenu
}: Props) => {
  return <MenuListContainer variants={menuContainerVariants}>
            <ChildrenList variants={menuVariants}>
                <ChildrenListTitle $isActive={false} href={'/promotion'} onClick={onCloseMenu}>
                    โปรโมชัน
                </ChildrenListTitle>
            </ChildrenList>
            <ChildrenList variants={menuVariants}>
                <ChildrenListTitle $isActive={false} href={'/news'} onClick={onCloseMenu}>
                    ข่าวสาร
                </ChildrenListTitle>
            </ChildrenList>
        </MenuListContainer>;
};
export default PromotionMenuMobile;